import { Component, inject } from '@angular/core';
import {Router} from '@angular/router';
import {Regioverantwoordelijke} from '../../../regioverantwoordelijke/regioverantwoordelijke';
import {RegioverantwoordelijkeService} from '../../../regioverantwoordelijke/regioverantwoordelijke.service';

@Component({
    templateUrl: './add-regioverantwoordelijke.page.html',
    styleUrls: ['./add-regioverantwoordelijke.page.scss'],
    standalone: false
})
export class AddRegioverantwoordelijkePage {
  private regioverantwoordelijkeService = inject(RegioverantwoordelijkeService);
  private router = inject(Router);

  private requestBusy = false;

  onCancelClicked(): void {
    this.navigateToRegioverantwoordelijken();
  }

  onAddClicked(regioverantwoordelijke: Regioverantwoordelijke): void {
    if (!this.requestBusy) {
      this.requestBusy = true;
      this.regioverantwoordelijkeService.postRegioverantwoordelijke$(regioverantwoordelijke)
        .subscribe(
          () => this.navigateToRegioverantwoordelijken(),
          () => this.requestBusy = false,
          () => this.requestBusy = false,
        );
    }
  }

  private navigateToRegioverantwoordelijken(): void {
    this.router.navigateByUrl('/regioverantwoordelijken');
  }
}
